<svg width="100%" height="100%" viewBox="0 0 64 54" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.156 50H27.53l15.125 14V50h20.187V0H1.156zm9.937-38.312h11.563l22.25 20.75v-20.75h7.375V38.5H41.094L18.47 17.375V38.5h-7.375z" fill="currentColor"/>
    <path d="M18.47 17.375L41.094 38.5H52.28V11.687h-7.374v20.75l-22.25-20.75H11.094V38.5h7.375z" fill="currentColor"/>
    <path d="M1.156 0h61.687v50H1.156z" fill="currentColor"/>
    <path d="M32 0h30.844v25H32z" fill="currentColor"/>
    <path d="M32 25h30.844v25H32z" fill="currentColor"/>
    <path d="M1.156 0H32v25H1.156z" fill="currentColor"/>
    <g fill="currentColor">
        <path d="M1.156 25H32v25H1.156z"/>
        <path d="M32 50l.154 4.303L27.53 50z"/>
    </g>
    <path d="M16.367 15.83l26.758 24.984h13.23V9.102h-8.722v24.54L21.32 9.102H7.644v31.71h8.722z" fill="#fff"/>
</svg>